import { HealthMetricsHistory } from 'features/Health/containers/MonetisationHealthChartContainer/types/healthMetrics';
import { deliveryHistory } from 'mocks/server/data/delivery';
import { demandHistory } from 'mocks/server/data/demand';
import { DELIVERY_OVERALL, DEMAND_OVERALL } from 'mocks/server/utils/constants';

const getAverage = (history: HealthMetricsHistory[]) => {
  return (
    history
      .map((historyItem) => historyItem.value)
      .reduce((sum, currentValue) => sum + currentValue, 0) / history.length
  );
};

export const monetisation = () => {
  return {
    delivery: {
      overall: DELIVERY_OVERALL === null ? getAverage(deliveryHistory) : DELIVERY_OVERALL,
      history: deliveryHistory,
    },
    demand: {
      overall: DEMAND_OVERALL === null ? getAverage(demandHistory) : DEMAND_OVERALL,
      history: demandHistory,
    },
  };
};
